function slide(title){
    if($(title).next().css("display")=="none"){
      $(title).children("div").html('<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="20" y="12.9" width="16" height="1.8" rx=".13" transform="rotate(-180 20 12.9)" fill="#fff"/><rect x="4" y="12.9" width="1.8" height="16" rx=".13" transform="rotate(-90 4 12.9)" fill="#fff"/></svg>');
    }else{
      $(title).children("div").html('<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="11.1" width="16" height="1.8" rx=".13" fill="#fff"/><rect x="11.1" y="4" width="1.8" height="16" rx=".13" fill="#fff"/></svg>');
    };
    $(title).next().slideToggle();
    $(title).parent().siblings().children(".sl-footer-link-content-mobile").slideUp();
    $(title).parent().siblings().children(".sl-footer-link-title-mobile").children("div").html('<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="11.1" width="16" height="1.8" rx=".13" fill="#fff"/><rect x="11.1" y="4" width="1.8" height="16" rx=".13" fill="#fff"/></svg>');
  }
  
  function hrefReload() {
    setTimeout(function(){
      location.reload(true);
    }, 300);
  }